<div class="container-adaptive">
    <div class="row">
        <div class="col">
            <div class="row mb-3">
                <div class="col">
                    <div class="filter">
                        <div class="filter-block" (click)="changeArrowState()" data-toggle="collapse"
                            data-target="#collapseFilter" aria-expanded="false" aria-controls="collapseBlock">
                            <span>
                                {{ 'CONSTANTS.BTN_FILTER' | translate | uppercase }}
                            </span>
                            <i class="material-icons">{{ expanded ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
                        </div>
                        <div class="collapse" id="collapseFilter">
                            <div class="filter-controls">
                                <div class="filter-controls-row">
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.PATIENT_TITLE' | translate | uppercase }}:</span>
                                        <input type="search" id="patientId" [(ngModel)]="patientIdValue"
                                            (search)="applyFilterByPatientId()" (keyup)="applyFilterByPatientId()">
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.ORDERED_TITLE' | translate | uppercase }}:</span>
                                        <input type="text" matInput ngxDaterangepickerMd [locale]="locale"
                                            [showClearButton]="true" [(ngModel)]="requestedDateRange"
                                            (change)="applyFilterByReqDate()" name="requestedDateRange" />
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.COMPLETED_TITLE' | translate | uppercase}}:</span>
                                        <input type="text" matInput ngxDaterangepickerMd [locale]="locale"
                                            [showClearButton]="true" [(ngModel)]="completedDateRange"
                                            (change)="applyFilterByCompDate()" name="completedDateRange" />
                                    </div>
                                </div>
                                <div class="filter-controls-row">
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.STATE_TITLE' | translate | uppercase }}:</span>
                                        <ng-select [clearable]="false" [dropdownPosition]="'bottom'"
                                            [(ngModel)]="selectedByDefaultStates" bindValue="id" bindLabel="name"
                                            [items]="statesList" [searchable]="false" (change)="applyFilterByState()">
                                        </ng-select>
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.ANALYSIS_TITLE' | translate | uppercase }}:</span>
                                        <ng-select class="analysis-types-filter" [clearable]="false" [dropdownPosition]="'bottom'"
                                            [(ngModel)]="selectedByDefaultAnalysis" bindValue="id" bindLabel="name"
                                            [items]="analysisList" [searchable]="false"
                                            (change)="applyFilterByAnalysis()">
                                        </ng-select>
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.ORDERING_TITLE' | translate | uppercase }}:</span>
                                        <input type="search" id="order" [(ngModel)]="orderingValue"
                                            (search)="applyFilterByOrdering()" (keyup)="applyFilterByOrdering()">
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.SOURCE_TITLE' | translate | uppercase }}:</span>
                                        <input type="search" id="source" [(ngModel)]="sourceValue"
                                            (search)="applyFilterBySource()" (keyup)="applyFilterBySource()">
                                    </div>
                                    <div class="filter-item">
                                        <span>{{ 'REQUEST_TABLE.VIEWED' | translate | uppercase }}:</span>
                                        <ng-select [clearable]="false" [dropdownPosition]="'bottom'"
                                            [(ngModel)]="selectedByDefaultViewed" bindValue="id" bindLabel="name"
                                            [items]="viewedList" [searchable]="false" (change)="applyFilterByViewed()">
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-100 mt-3 table-block">
                <div class="table-header">
                    <span>
                        {{ 'REQUEST_TABLE.TABLE_TITLE' | translate | uppercase }}
                    </span>
                </div>
                <table mat-table [dataSource]="dataSource" matSort
                    (matSortChange)="helper.onSortTable($event, tableService)"
                    [matSortDirection]="tableService.sort?.isDescending ? 'desc' : 'asc'">
                    <ng-container matColumnDef="patientId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.PATIENT_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="row.patientId; else emptyPatient" title="{{ row.patientId }}">{{
                                row.patientId }}</span>
                            <ng-template #emptyPatient>
                                <span>-</span>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.ORDERED_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span title="{{ row.created | iso8601 }}">{{ row.created | iso8601 }}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="modified">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.COMPLETED_TITLE' | translate | uppercase}} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="isCompletedState(row.state); else showNothing"
                                title="{{ row.modified | iso8601 }}">{{ row.modified | iso8601 }}</span>
                            <ng-template #showNothing>
                                <span>-</span>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.STATE_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span title="{{ getTranslateState(row.state) }}"
                                [ngClass]="{'processed_class': isCompletedState(row.state)}">{{
                                getTranslateState(row.state) }}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="analysis">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.ANALYSIS_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span title="{{ row.analysis }}">{{ 'REQUEST_TABLE.' + row.analysis |translate }}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="ordering">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.ORDERING_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="row.ordering; else emptyOrdering" title="{{ row.ordering }}">{{ row.ordering
                                }}</span>
                            <ng-template #emptyOrdering>
                                <span>-</span>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="source">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.SOURCE_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="row.source; else emptySource" title="{{ row.source }}">{{ row.source
                                }}</span>
                            <ng-template #emptySource>
                                <span>-</span>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="fileName">
                        <mat-header-cell *matHeaderCellDef>
                            <span> {{ 'REQUEST_TABLE.FILE_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <ng-container *appHasPermission="['portal.user', 'customer.admin', 'customer.user']">
                                <div *ngIf="(isCompletedState(row.state) || isFailedState(row.state))"
                                    (click)="getReportFile(row.requestId)" class="d-flex align-items-center pointer">
                                    <a> {{ 'REQUEST_TABLE.DOWNLOAD_PDF' | translate }} </a>
                                    <i class="material-icons">picture_as_pdf</i>
                                </div>
                            </ng-container>
                            <ng-container *appHasPermission="['portal.admin']">
                                <div *ngIf="isPendingState(row.state)" (click)="retriggerRequest(row.requestId)"
                                    class="mat-cell-re-trigger">
                                    <div class="d-flex align-items-center pointer">
                                        <a> {{ 'REQUEST_TABLE.RE_TRIGGER' | translate | uppercase }} </a>
                                        <i class="material-icons"
                                            [ngClass]="{'rotation-spin': isRotateSpin && row.id === rowId}">sync</i>
                                    </div>
                                </div>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="lastViewed">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span> {{ 'REQUEST_TABLE.VIEWED_TITLE' | translate | uppercase }} </span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="isCompletedState(row.state); else emptyLastViewed" title="{{ ( row.lastViewed ?
                                'REQUEST_TABLE.VIEWED' : 'REQUEST_TABLE.NOT_VIEWED' ) | translate }}"> {{ (
                                row.lastViewed ?
                                'REQUEST_TABLE.VIEWED' : 'REQUEST_TABLE.NOT_VIEWED' ) | translate }}</span>
                            <ng-template #emptyLastViewed>
                                <span>-</span>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="tableOrderHeader"
                        [ngStyle]="{'display': usersPaginated && usersPaginated.totalCount === 0 ? 'none' : 'flex'}"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: tableOrderHeader;"
                        [ngClass]="{'pending_style': isPendingState(row.state), 'failed_class': isFailedState(row.state), 'bold_style': isCompletedState(row.state) && !row.lastViewed }">
                    </mat-row>
                </table>
            </div>

            <div class="table-msg" *ngIf="usersPaginated && usersPaginated.totalCount === 0">
                <b> {{ 'CONSTANTS.NO_DATA' | translate }} </b>
            </div>

            <mat-paginator class="table-paginator" [pageSizeOptions]="[5, 10, 20]" [length]="usersPaginated?.totalCount"
                [pageSize]="usersPaginated?.pageSize" [pageIndex]="usersPaginated?.page - 1"
                (page)="helper.onPage($event, tableService)"
                [ngStyle]="{'display': usersPaginated && usersPaginated.totalCount === 0 ? 'none' : ''}">
            </mat-paginator>
        </div>
    </div>

    <input #fileUpload hidden type="file" (change)="fileAdd($event)" />
    <input #folderUpload hidden type="file" webkitdirectory (change)="fileAdd($event)" />
    <app-patient-id-modal (patientId)="confirmFileName($event)"></app-patient-id-modal>
    <app-info-modal></app-info-modal>
    <app-downloading-modal></app-downloading-modal>
</div>